<sm-toolbar class="mt-2 flex-item-fixed" [noBorder]=true [spaceBetween]=true>
    <div class="flex-row gap-1">
        @if (calendarWrapper != null) {
            @if (!calendarWrapper.resourceView) {
                <button pButton icon="fas fa-chevron-left" (click)="calendarWrapper.prev()"></button>
                <button pButton icon="fas fa-chevron-right" (click)="calendarWrapper.next()"></button>
            }
            <button class="mr-3" pButton icon="fas fa-calendar-day" [label]="app.t('ProjectPlanning.today')" (click)="jumpToToday()"></button>
        }
        <button pButton icon="fas fa-plus" [label]="app.t('entity.Project.entityName')" (click)="addProject()"></button>
        <button pButton icon="fas fa-plus" [label]="app.t('entity.CalendarEvent.other.task')" (click)="addTask()"></button>
        @if (!forProjects) {
            <button pButton icon="fas fa-plus" [label]="app.t('entity.CalendarEvent.other.appointment')" (click)="addAppointment()"></button>
        }
        @if (project!= null) {
            <button pButton icon="fas fas fa-pencil" [pTooltip]="app.t('ProjectPlanning.editProject')" (click)="editProject()"></button>
            <button pButton icon="fas fa-users" [pTooltip]="app.t('ProjectPlanning.assignResponsibilities')" (click)="editProjectRoles()"></button>
        }
        @if (calendarWrapper != null && !calendarWrapper.resourceView) {
            <span class="ml-8 font-size-15rem font-bold title">{{calendarWrapper.getTitle()}}</span>
        }
        @if (showSummary && summary != null) {
        <div class="ml-4 status-banner">
            <div class="status-item">
                <span class="count">{{ summary.overdueCount }}</span>
                <span class="label">{{app.t('ProjectPlanning.overdue')}}</span>
            </div>
            <div class="status-item">
                <span class="count">{{ summary.todayTasksCount }}</span>
                <span class="label">{{app.t('ProjectPlanning.dueToday')}}</span>
            </div>
            <div class="status-item">
                <span class="count">{{ summary.todayAppointmentsCount }}</span>
                <span class="label">{{app.t('ProjectPlanning.todaysAppointments')}}</span>
            </div>
        </div>
        }
    </div>
</sm-toolbar>
